import { render, staticRenderFns } from "./AutoReplenishment.vue?vue&type=template&id=4001809c&"
import script from "./AutoReplenishment.vue?vue&type=script&lang=js&"
export * from "./AutoReplenishment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports